import React from 'react';
import moment from 'moment';
import { toArray } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
    EBON_ACTIVATION_TYPE_ONLINE,
    EBON_ACTIVATION_TYPE_OFFLINE,
    EBON_ACTIVATION_TYPE_ONLINE_AND_OFFLINE
} from '../../../constants/ebon';
import { PATH } from '../../../constants/path';
import { MOMENTJS_DATE_FORMAT } from '../../../constants/moment';
import { MODAL_TYPE_LOGIN } from '../../../services/modal/constants';
import { SSO_URL, USE_PARITY, APPLICATION_ID, NO_DISCOUNT } from '../../../constants';

import { showModal } from '../../../services/modal/actions';

import { getPartner, getEbonPartner } from '../../../services/partner/selector';
import { getI18nByApp, getRefundWording } from '../../../services/i18n/selector';
import {
    getInstertitielCashbackUrl,
    displayableCashback,
    hasCashback,
    hasCashbackOffline,
    hasEbon,
    hasEbonCashback,
    renderPluralConditional
} from '../../../services/partner/utils';

import LinkButtonComponent from '../../button/LinkButtonComponent';
import PartnerBlockHorizontalComponent from '../../partner/PartnerBlockHorizontalComponent';

const DELAI_VALIDATION_DEFAULT = 15;

class HeaderComponent extends React.Component {
    showLoginModal = redirection => event => {
        const { isAuthenticated, showModal } = this.props;
        if (!isAuthenticated) {
            event.preventDefault();
            showModal(MODAL_TYPE_LOGIN, {
                redirectUrl: SSO_URL
            });
            return false;
        }
    };

    getLabelText = () => {
        const { i18nCurrency, i18n } = this.props;
        switch (true) {
            case USE_PARITY:
                return i18nCurrency.PARITY_CONDITION;
            default:
                return getI18nByApp(i18n, 'feature.partenaire.EBON_DISCOUNT_LABEL');
        }
    };

    getAvailability = e => {
        const { i18n } = this.props;

        if (e.activationType === EBON_ACTIVATION_TYPE_ONLINE_AND_OFFLINE) {
            return getI18nByApp(i18n, 'page.MERCHANTCARD.EBON_TYPE_ON_OFF');
        } else if (e.activationType === EBON_ACTIVATION_TYPE_ONLINE) {
            return getI18nByApp(i18n, 'page.MERCHANTCARD.EBON_TYPE_ON');
        } else if (e.activationType === EBON_ACTIVATION_TYPE_OFFLINE) {
            return getI18nByApp(i18n, 'page.MERCHANTCARD.EBON_TYPE_OFF');
        }
        return null;
    };

    renderCashback = () => {
        const {
            i18n,
            i18nPartner,
            partner,
            isOffline,
            discounts,
            isEbon,
            ebonPartner,
            refundWording
        } = this.props;
        if (
            (partner &&
                ((!isOffline && hasCashback(partner)) ||
                    (isOffline && hasCashbackOffline(partner)))) ||
            (isEbon && hasEbon(ebonPartner) && hasEbonCashback(ebonPartner))
        ) {
            const ebonDiscount =
                isEbon && USE_PARITY
                    ? ebonPartner.ebonDiscount.parity
                    : ebonPartner.ebonDiscount.cashback;
            const { percent, fixed, initialPercent, initialFixed, label } = isOffline
                ? partner.mostDisplayableDiscountOffline
                : isEbon && ebonPartner && ebonPartner.ebonDiscount
                ? {
                      fixed: ebonDiscount.fixed.value,
                      percent: ebonDiscount.percent.value,
                      initialPercent: ebonDiscount.percent.initialValue
                  }
                : partner.mostDisplayableDiscountOnline;
            const initialCashback = displayableCashback(initialPercent, initialFixed, USE_PARITY);
            const isMultiDiscount =
                discounts &&
                !isEbon &&
                discounts.filter(d => (isOffline ? d.offlineActive : d.onlineActive)).length > 1;

            return !NO_DISCOUNT ? (
                <div className="cashback">
                    <span className="upTo">{isMultiDiscount && `${i18nPartner.jusqua} `}</span>
                    <span>
                        <span className="value">
                            {`${displayableCashback(percent, fixed)} ${renderPluralConditional(
                                refundWording,
                                () => percent > 1 || fixed > 1
                            )}`}
                        </span>
                    </span>

                    {label || (
                        <span>
                            {this.getLabelText()}
                            {initialCashback && (
                                <span className="olieu grey">
                                    &nbsp;
                                    {i18nPartner.aulieude} {initialCashback}
                                </span>
                            )}
                        </span>
                    )}
                </div>
            ) : (
                <div className="cashback">
                    {getI18nByApp(i18n, 'feature.partenaire.NO_DISCOUNT')}
                </div>
            );
        } else {
            return <div className="cashback">{i18nPartner.pasdecashbackencemoment}</div>;
        }
    };

    // render the estimated date validation block
    renderEstimatedValidationDate = () => {
        const { partner, i18nPage, isEbon } = this.props;

        if (isEbon) return null;

        const validationDelay = partner ? partner.validationDelay : DELAI_VALIDATION_DEFAULT;
        const isValidationAfterServiceConsumption =
            partner && partner.validationAfterServiceConsumption;
        const estimatedValidationDate = moment()
            .add(validationDelay, 'days')
            .format(MOMENTJS_DATE_FORMAT);

        return partner && partner.validationDelay > -1 && hasCashback(partner) ? (
            <div className="validation-date">
                {`${i18nPage.ESTIMATED_VALIDATION_DATE} `}
                <br className="show-mobonly" />
                <span>
                    {isValidationAfterServiceConsumption
                        ? i18nPage.VALIDATION_AFTER_SERVICE_CONSUMPTION
                        : estimatedValidationDate}
                </span>
            </div>
        ) : null;
    };

    renderCTAButton = () => {
        const { isOffline, isEbon, partner, i18nPage } = this.props;
        const url = getInstertitielCashbackUrl(partner);

        if (!isEbon && !isOffline && partner) {
            return (
                <LinkButtonComponent
                    color="main"
                    text={i18nPage.TAKETHEOFFER}
                    title={i18nPage.TAKETHEOFFER}
                    to={url}
                    target="_blank"
                    onClick={this.showLoginModal(url)}
                />
            );
        }
        if (isOffline && partner) {
            return (
                <LinkButtonComponent
                    color="main"
                    text={i18nPage.SEND_TICKET}
                    title={i18nPage.SEND_TICKET}
                    to={`${PATH.FLASHING_TICKET_PAGE}?id=${partner.id}`}
                    onClick={this.showLoginModal(url)}
                />
            );
        }

        return null;
    };

    render() {
        const { partner, isEbon, ebonPartner } = this.props;
        const currentPartner = isEbon ? ebonPartner : partner;

        return (
            <PartnerBlockHorizontalComponent
                partner={currentPartner}
                noLogoLink
                cssClass="fm-entete">
                <div className="fm-entete-offre-bt grid has-gutter flex-center-alt">
                    <div className="fm-entete-offre">
                        {this.renderCashback()}
                        {this.renderEstimatedValidationDate()}
                        {isEbon && ebonPartner && ebonPartner.ebonDiscount && (
                            <p className="availabilityType">
                                {this.getAvailability(ebonPartner.ebonDiscount)}
                            </p>
                        )}
                    </div>
                    {!isEbon && (
                        <div className="fm-entete-bt one-third flex-container-v">
                            {this.renderCTAButton()}
                        </div>
                    )}
                </div>
            </PartnerBlockHorizontalComponent>
        );
    }
}

HeaderComponent.propTypes = {
    id: PropTypes.string.isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => {
    const partner = getPartner(state, ownProps.id);
    const ebonPartner = getEbonPartner(state, Number(ownProps.id));
    const isEbon = ownProps.isEbon;

    return {
        partner,
        ebonPartner,
        i18n: state.i18n,
        i18nPartner: state.i18n.feature.partenaire,
        i18nPage: state.i18n.page.MERCHANTCARD,
        i18nCurrency: state.i18n.CURRENCY,
        locale: state.i18n.locale,
        isAuthenticated: state.authentication.isAuthenticated,
        discounts: !isEbon ? toArray(state.discount.discounts[partner.id]) : null,
        refundWording: getRefundWording(state, APPLICATION_ID)
    };
};

const mapDispatchToProps = {
    showModal
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeaderComponent));



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/HeaderComponent.js